// Camera Exceptions
import { BatchCaptureNotImplementedException, CameraException } from './CameraExceptions';

export { BatchCaptureNotImplementedException, CameraException };

// CameraCaptureService
import { CameraCaptureService } from './CameraCaptureService';

export { CameraCaptureService };

// Camera capture types
import {
    BatchPhotoCaptureConfig,
    BatchPhotoUploadResult,
    MediaCentralPhotoUploadResult,
    PhotoCaptureConfig,
    PhotoUploadProgress,
    PhotoUploadResult,
    TeamBucketPhotoUploadResult,
} from './CameraTypes';

export { BatchPhotoCaptureConfig, BatchPhotoUploadResult, MediaCentralPhotoUploadResult, PhotoCaptureConfig, PhotoUploadProgress, PhotoUploadResult, TeamBucketPhotoUploadResult };

// Batch capture test double (testing aid for consumers; not a runtime fallback)
import { BatchCaptureFake, BatchCaptureTestDoubleOptions, createBatchCaptureTestDouble } from './BatchCaptureTestDouble';

export { BatchCaptureFake, BatchCaptureTestDoubleOptions, createBatchCaptureTestDouble };
